import { isNumber } from 'lodash/fp';
import { PriceService } from '../../../../services';
import { Maybe, StockCardPriceUpdateInput } from '../../../../generated/graphql';

interface GetPriceUpdateArgs {
    priceWithoutVat?: Maybe<number>;
    warehouseIds: string[];
    priceService: PriceService;
}

export const getPriceUpdateArgs = ({ priceWithoutVat, warehouseIds, priceService }: GetPriceUpdateArgs) => {
    const parsedPriceWithoutVat = isNumber(priceWithoutVat) ? priceService.toInteger(priceWithoutVat) : undefined;
    const priceUpdateArgs: StockCardPriceUpdateInput | null = isNumber(parsedPriceWithoutVat)
        ? { priceWithoutVat: parsedPriceWithoutVat, warehouseIds }
        : null;

    return priceUpdateArgs;
};